export * from './kanzi-sales-treemap-chart.component';
